import { useEffect, useState } from 'react'
import { generatePath, Link, Redirect, useLocation } from 'react-router-dom'

import { useAuth } from 'hooks/UseAuth'
import { currentPath } from 'utils/urlUtils'
import { getCurrentWorkspace } from 'utils'
import { HOME_PATH, LOGIN_OR_SIGNUP_PATH, WORKSPACE_IMPORT_PATH, WORKSPACE_PATH } from 'paths'
import { UserClient } from 'api/clients/UserClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import Styles from './QuickRedirect.module.scss'
import { reportError } from 'utils/error'

export const QuickRedirect = () => {
  const auth = useAuth()
  const location = useLocation()
  const workspace = getCurrentWorkspace()
  const [lastWorkspaceId, setLastWorkspaceId] = useState<number | null | undefined>(null)
  const [fetchingLastWorkspaceId, setFetchingLastWorkspaceId] = useState<boolean>(true)

  useEffect(() => {
    const fetchLastWorkspaceId = async () => {
      const res = await UserClient.lastWorkspaceId()
      if (res.type === SUCCESS_RESPONSE_TYPE) setLastWorkspaceId(res.data.last_workspace_id)
      setFetchingLastWorkspaceId(false)
    }

    if (workspace?.id || auth?.last_workspace_id) {
      setLastWorkspaceId(workspace?.id || auth?.last_workspace_id)
    } else if (auth) {
      fetchLastWorkspaceId()
    }
  }, [workspace, auth, lastWorkspaceId])

  if (!auth) return <Redirect to={{ pathname: LOGIN_OR_SIGNUP_PATH, search: `redirect_to=${currentPath(location)}` }} />

  if (lastWorkspaceId) {
    const redirectUrls: { [key: string]: string } = {
      '/import': generatePath(WORKSPACE_IMPORT_PATH, { workspaceId: lastWorkspaceId }),
      '/recent': generatePath(WORKSPACE_PATH, { workspaceId: lastWorkspaceId }),
    }
    return <Redirect to={redirectUrls[location.pathname]} />
  }

  if (fetchingLastWorkspaceId) return <div className={Styles.message}>Fetching your last workspace...</div>

  reportError('Failed to perform redirect', {
    severity: 'error',
    metaData: { lastWorkspaceId },
  })

  return (
    <div className={Styles.message}>
      Something wrong happened. Our team has been notified. Click <Link to={HOME_PATH}>here</Link> to access Blaze.
    </div>
  )
}

export default QuickRedirect
